import { render, staticRenderFns } from "./select-vehicle.vue?vue&type=template&id=5e4575ae&scoped=true&"
import script from "./select-vehicle.vue?vue&type=script&lang=js&"
export * from "./select-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4575ae",
  null
  
)

export default component.exports